var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "player", staticClass: "video-container" }, [
    _vm.videoSource === "youtube" ? _c("div", { ref: "yplayer" }) : _vm._e(),
    _vm._v(" "),
    _vm.videoSource === "vimeo"
      ? _c("iframe", {
          ref: "vplayer",
          attrs: {
            src:
              "https://player.vimeo.com/video/" +
              _vm.videoId +
              "?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media",
            allowfullscreen: "",
            allowtransparency: "",
            allow: "autoplay",
            title: _vm.videoTitle
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.videoSource === "warpwire"
      ? _c("iframe", {
          attrs: {
            src: "https://udayton.warpwire.com/w/" + _vm.videoId,
            allow: "autoplay; encrypted-media; fullscreen; picture-in-picture;",
            id: "ww_" + _vm.videoId,
            "data-ww-id": "ww_" + _vm.videoId,
            allowfullscreen: "",
            title: _vm.videoTitle
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.videoSource === "campusreel"
      ? _c("div", { attrs: { id: "campusreel_" + _vm.videoId } }, [
          _vm._v("Loading the player...")
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ef35988", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ef35988","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoPlayer.vue
// module id = null
// module chunks = 